import Spinner from '@rio-cloud/rio-uikit/lib/es/Spinner';
import React from 'react';

export const LoadingIndicator = (): React.JSX.Element => (
    <div data-testid="loading-spinner" className={'display-flex justify-content-center'}>
        <Spinner />
    </div>
);
